// extracted by mini-css-extract-plugin
module.exports = {"draft":"Draft_draft__3_nqw","title":"Draft_title__2Az1N","button":"Draft_button__SfvZN"};